import * as React from "react"
import { connect } from "react-redux"
import { RequestStateProps } from "../interfaces/RequestState"
import { State } from "../interfaces/State"
import { getRequestsByList, isSuccessful, isError, isPending } from "../redux/requests/selectors"

export default function withRequestState<P extends RequestStateProps>(Component : React.ComponentType<P>, types : string[]){
    class ComponentWithRequestState extends React.Component<RequestStateProps> {
        render(){
            return (
                <Component {...this.props as P} />
            )
        }
    }
    return connect<RequestStateProps, any, any>((state : State) : RequestStateProps => {
      return {
        isPending: isPending(state, types),
        hasError: isError(state, types),
        isSuccessful: isSuccessful(state, types),
        requests: getRequestsByList(state, types)
      }
    }, null)(ComponentWithRequestState);
}